// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../differenceInMonths/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var differenceInMonths = convertToFP(fn, 2);
export default differenceInMonths;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/differenceInMonths/index.js
// module id = 840
// module chunks = 0